export default {
    customDateFormatter(data, anoMesDia = false) {
        let dia = data.getDate().toString(),
            diaF = (dia.length == 1) ? '0' + dia : dia,
            mes = (data.getMonth() + 1).toString(),
            mesF = (mes.length == 1) ? '0' + mes : mes,
            anoF = data.getFullYear();
        return (anoMesDia) ? anoF + "-" + mesF + "-" + diaF : diaF + "/" + mesF + "/" + anoF;
    },
    validarEmail(email) {
        var emailFilter = /^[^@]+@[^@.]+\.[^@]*\w\w$/
        // eslint-disable-next-line
        var illegalChars = /[\(\)\<\>\,\;\:\\\"\[\]]/
        return email === "" || !emailFilter.test(email) || email.match(illegalChars) ? false : true
    },

    validarCPF(str) {
        str = str.replace('.', '');
        str = str.replace('.', '');
        str = str.replace('.', '');
        str = str.replace('-', '');

        if (str.length != 11) {
            return false;
        }

        let digitos_iguais = 0, soma = 0, resto
        for (let i = 0; i < str.length - 1; i++)
            if (str.charAt(i) == str.charAt(i + 1)) {
                digitos_iguais++;
            }
        if (digitos_iguais == str.length) {
            return false;
        }

        for (let i = 1; i <= 9; i++) {
            soma = soma + parseInt(str.substring(i - 1, i)) * (11 - i);
        }

        resto = (soma * 10) % 11;

        if ((resto == 10) || (resto == 11)) {
            resto = 0;
        }

        if (resto != parseInt(str.substring(9, 10))) {
            return false;
        }

        soma = 0;

        for (let i = 1; i <= 10; i++) {
            soma = soma + parseInt(str.substring(i - 1, i)) * (12 - i);
        }

        resto = (soma * 10) % 11;

        if ((resto == 10) || (resto == 11)) {
            resto = 0;
        }

        if (resto != parseInt(str.substring(10, 11))) {
            return false;
        }

        return true;
    },
    validarCNPJ(str) {
        str = str.replace('.', '');
        str = str.replace('.', '');
        str = str.replace('.', '');
        str = str.replace('-', '');
        str = str.replace('/', '');

        let cnpj = str, numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais = 1;

        if (cnpj.length != 14) {
            return false;
        }

        for (let i = 0; i < cnpj.length - 1; i++) {
            if (cnpj.charAt(i) != cnpj.charAt(i + 1)) {
                digitos_iguais = 0;
                break;
            }
        }

        if (!digitos_iguais) {
            tamanho = cnpj.length - 2
            numeros = cnpj.substring(0, tamanho);
            digitos = cnpj.substring(tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) {
                    pos = 9;
                }
            }

            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) {
                return false;
            }

            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;

            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) {
                    pos = 9;
                }
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) {
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    }
}